// extracted by mini-css-extract-plugin
export default {"recipeTitle":"recipe_recipeTitle__IqeMw"};